import { render, staticRenderFns } from "./PagibigContributionMain.vue?vue&type=template&id=7468909a"
import script from "./PagibigContributionMain.vue?vue&type=script&lang=js"
export * from "./PagibigContributionMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports